<div #advancedSearchShell class="advanced-search-shell" [ngClass]="{'is-hidden': isHidden}">
  <input
    *ngIf="attachmentsEnabled"
    #fileInput
    class="hidden-file-input"
    type="file"
    accept="image/*"
    multiple
    (change)="onFileInputChange($event)">

  <div #collapsedRow *ngIf="!isExpanded" class="collapsed-row">
    <div #collapsedStart class="collapsed-side collapsed-side-start">
      <button
        class="nav-icon-btn collapsed-plus-btn"
        type="button"
        [attr.aria-label]="collapsedLibraryButtonAriaLabel"
        [ngClass]="{'is-back-mode': isLibraryButtonInBackMode}"
        (click)="onLibraryClick($event)">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M9 3.75V14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M3.75 9H14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="collapsed-composer" [ngClass]="{'is-busy': isBusy, 'is-submit-hidden': !collapsedSubmitVisible}" (click)="onCollapsedComposerClick($event)">
      <button
        *ngIf="attachmentsEnabled"
        class="search-plus-btn collapsed-add-btn"
        type="button"
        [disabled]="isBusy"
        (pointerdown)="onPlusRipplePointerDown($event)"
        (click)="onAddImageClick($event)">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M9 3.75V14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M3.75 9H14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>

      <input
        #collapsedPromptInput
        class="collapsed-prompt-input"
        type="text"
        *ngIf="!pairBatchProgress"
        [(ngModel)]="prompt"
        [disabled]="isBusy"
        [placeholder]="expandedPlaceholder"
        (click)="$event.stopPropagation()"
        (input)="onCollapsedPromptInput()"
        (keydown)="onCollapsedPromptKeydown($event)">

      <div *ngIf="pairBatchProgress" class="pair-gen-status">
        <div class="pair-gen-label">Generating pair previews {{ pairBatchProgress.done }}/{{ pairBatchProgress.total }}…</div>
        <div class="pair-gen-bar-track">
          <div class="pair-gen-bar-fill" [style.width.%]="pairBatchProgressPct"></div>
        </div>
      </div>

      <button
        class="composer-submit-btn"
        type="button"
        [attr.aria-label]="primaryActionLabel"
        [ngClass]="{'composer-save-collection-btn': shouldShowSaveCollectionAction || isBusy}"
        [disabled]="isPrimaryActionDisabled || isBusy"
        (click)="onPrimaryActionClick($event)">
        <svg *ngIf="!isBusy && !shouldShowSaveCollectionAction" class="composer-submit-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="18" transform="rotate(90 18 18)" fill="white"/>
          <path d="M13 16L18 11L23 16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18 23L18 12" stroke="black" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <svg *ngIf="!isBusy && shouldShowSaveCollectionAction || isBusy" class="composer-save-collection-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
          <circle cx="18" cy="18" r="16.5" stroke="white" stroke-width="2"/>
          <path d="M18 11.5V24.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
          <path d="M11.5 18H24.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div #collapsedEnd class="collapsed-side collapsed-side-end">
      <button *ngIf="devButtonVisible" class="nav-icon-btn account-btn dev-btn" type="button" aria-label="Dev" (click)="onDevClick($event)">
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="3" cy="10.5" r="2" fill="white" />
          <circle cx="11" cy="10.5" r="2" fill="white" />
          <circle cx="19" cy="10.5" r="2" fill="white" />
        </svg>
        <span class="web-btn-text">Dev</span>
      </button>

      <button *ngIf="!devButtonVisible" class="nav-icon-btn account-btn" type="button" [ngClass]="{'is-faded-out': hideAccountButton}" (click)="onAccountClick($event)">
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="3" cy="10.5" r="2" fill="white" />
          <circle cx="11" cy="10.5" r="2" fill="white" />
          <circle cx="19" cy="10.5" r="2" fill="white" />
        </svg>
        <span class="web-btn-text">Account</span>
      </button>
    </div>
  </div>

  <div #expandedRow *ngIf="isExpanded" class="expanded-row">
    <div class="expanded-base"></div>

    <div #expandedStart class="expanded-side expanded-side-start">
      <button class="nav-icon-btn expanded-nav-btn back-btn" type="button" (click)="onBackClick($event)">
        <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="web-btn-text">Back</span>
      </button>
    </div>

    <div class="composer-card" [ngClass]="{'is-busy': isBusy}" (click)="onCollapsedComposerClick($event)">
      <div class="composer-top">
        <div class="preview-strip" *ngIf="attachmentsEnabled && attachments.length > 0">
          <div
            *ngFor="let attachment of attachments; trackBy: trackByAttachmentId"
            class="preview-thumb"
            [style.backgroundImage]="'url(' + attachment.previewUrl + ')'">
            <button class="preview-remove-btn" type="button" (click)="onAttachmentRemove(attachment, $event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 11 11" fill="none">
                <path d="M1 1L10 10" stroke="#202020" stroke-width="1.4" stroke-linecap="round"/>
                <path d="M10 1L1 10" stroke="#202020" stroke-width="1.4" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div class="composer-input-row">
        <button
          *ngIf="attachmentsEnabled"
          class="composer-icon-btn search-plus-btn add-btn"
          type="button"
          (pointerdown)="onPlusRipplePointerDown($event)"
          (click)="onAddImageClick($event)">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M9 3.75V14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M3.75 9H14.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>

        <textarea
          #promptTextarea
          class="composer-textarea"
          [(ngModel)]="prompt"
          [disabled]="isBusy"
          [placeholder]="expandedPlaceholder"
          rows="1"
          (input)="onPromptInput()"></textarea>

        <button
          class="composer-submit-btn composer-submit-btn-expanded"
          type="button"
          [attr.aria-label]="primaryActionLabel"
          [ngClass]="{'composer-save-collection-btn': shouldShowSaveCollectionAction || isBusy}"
          [disabled]="isPrimaryActionDisabled || isBusy"
          (click)="onPrimaryActionClick($event)">
          <svg *ngIf="!isBusy && !shouldShowSaveCollectionAction" class="composer-submit-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <circle cx="18" cy="18" r="18" transform="rotate(90 18 18)" fill="white"/>
            <path d="M13 16L18 11L23 16" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18 23L18 12" stroke="black" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <svg *ngIf="!isBusy && shouldShowSaveCollectionAction || isBusy" class="composer-save-collection-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <circle cx="18" cy="18" r="16.5" stroke="white" stroke-width="2"/>
            <path d="M18 11.5V24.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
            <path d="M11.5 18H24.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>

    <div #expandedEnd class="expanded-side expanded-side-end side-actions">
      <button class="nav-icon-btn expanded-nav-btn side-action-btn share-btn" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="24" viewBox="0 0 19 24" fill="none">
          <path d="M3.33637 24H15.6638C16.7401 24 17.5519 23.7265 18.0992 23.1795C18.6464 22.6324 18.9201 21.8256 18.9201 20.7589V9.95557C18.9201 8.8889 18.6464 8.08435 18.0992 7.54189C17.5519 6.99946 16.7401 6.72824 15.6638 6.72824H12.6401V8.24618H15.6364C16.1928 8.24618 16.6261 8.39432 16.9362 8.69062C17.2463 8.98691 17.4014 9.43135 17.4014 10.0239V20.6906C17.4014 21.2832 17.2463 21.7276 16.9362 22.0239C16.6261 22.3202 16.1928 22.4683 15.6364 22.4683H3.36374C2.79821 22.4683 2.36267 22.3202 2.05712 22.0239C1.75154 21.7276 1.59876 21.2832 1.59876 20.6906V10.0239C1.59876 9.43135 1.75154 8.98691 2.05712 8.69062C2.36267 8.39432 2.79821 8.24618 3.36374 8.24618H6.36006V6.72824H3.33637C2.26006 6.72824 1.44827 6.99718 0.90099 7.53506C0.353716 8.07296 0.0800781 8.87979 0.0800781 9.95557V20.7589C0.0800781 21.8347 0.353716 22.6438 0.90099 23.1863C1.44827 23.7287 2.26006 24 3.33637 24Z" fill="white"/>
          <path d="M9.49305 15.6717C9.70283 15.6717 9.88297 15.6011 10.0335 15.4598C10.184 15.3185 10.2592 15.143 10.2592 14.9333V3.66496L10.1908 2.07863L11.0254 2.96751L12.763 4.77262C12.8907 4.92761 13.0595 5.00511 13.2693 5.00511C13.4699 5.00511 13.6364 4.94129 13.7687 4.81365C13.9009 4.68602 13.967 4.52647 13.967 4.33502C13.967 4.1527 13.8895 3.98859 13.7345 3.84272L10.0403 0.246151C9.9491 0.154979 9.86017 0.0911611 9.77353 0.0546963C9.68687 0.0182316 9.59338 0 9.49305 0C9.40183 0 9.31289 0.0182316 9.22623 0.0546963C9.13959 0.0911611 9.0461 0.154979 8.94575 0.246151L5.25164 3.84272C5.09658 3.98859 5.01904 4.1527 5.01904 4.33502C5.01904 4.52647 5.08289 4.68602 5.21059 4.81365C5.33829 4.94129 5.50703 5.00511 5.71681 5.00511C5.92661 5.00511 6.09992 4.92761 6.23674 4.77262L7.96065 2.96751L8.80895 2.07863L8.74052 3.66496V14.9333C8.74052 15.143 8.81578 15.3185 8.96629 15.4598C9.11679 15.6011 9.29238 15.6717 9.49305 15.6717Z" fill="white"/>
        </svg>
        <span class="web-btn-text">Share</span>
      </button>

      <button class="nav-icon-btn expanded-nav-btn side-action-btn added-btn" type="button" [ngClass]="{'is-active': attachments.length > 0}">
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23ZM11.8032 15.7866C11.5903 16.0964 11.3195 16.2513 10.9905 16.2513C10.8164 16.2513 10.6616 16.2174 10.5262 16.1496C10.3907 16.0819 10.2601 15.9609 10.1344 15.7866L7.23216 12.2582C7.07739 12.0549 7 11.8468 7 11.6338C7 11.4112 7.07497 11.2224 7.22491 11.0676C7.37487 10.9127 7.5611 10.8352 7.78359 10.8352C7.91903 10.8352 8.04479 10.8643 8.16087 10.9223C8.27697 10.9804 8.39789 11.0869 8.52364 11.2418L10.947 14.3056L15.8953 6.45013C16.0791 6.15004 16.3064 6 16.5773 6C16.7901 6 16.9812 6.06776 17.1505 6.20329C17.3198 6.33881 17.4044 6.51789 17.4044 6.74052C17.4044 6.85669 17.3778 6.96802 17.3246 7.0745C17.2714 7.18098 17.2158 7.28262 17.1577 7.37943L11.8032 15.7866Z" fill="white"/>
        </svg>
        <span class="web-btn-text">Added</span>
      </button>
    </div>
  </div>
</div>
